import { actions } from '../constants/background';
import * as actionTypes from '../../models/action/background';
import { IQuestionList } from '../../models/action/question';
import { IFilter } from '../../models/components/questions';
import { IPagedQueryS } from '../../models/components/paginate';
import { VirtualClassReportType } from '../../models/enums/VirtualClassReportType';

export function GetActivityReport(activityId: string, classId: string, isDetailed: boolean, virtualClassReportType?: VirtualClassReportType, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetActivityReport {
    return {
        activityId,
        classId,
        isDetailed,
        virtualClassReportType,
        type: actions.GET_ACTIVITY_REPORT,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function GetQuestionBankExcelDownload(filters: IFilter, paging: IPagedQueryS, questionIdList: string[], IsAllSelected: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetQuestionBankExcelDownload {
    return {
        filters,
        paging,
        questionIdList,
        IsAllSelected,
        type: actions.GET_QUESTION_BANK_EXCEL_DOWNLOAD,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}


export function GetAttendanceExcelDownload(selectedAttendanceIds: Array<string>,isAll:boolean, ClassId: string, CourseId: string, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IDownloadAttendance {
    return {
        selectedAttendanceIds,
        isAll,
        ClassId,
        CourseId,
        callback,
        type: actions.DOWNLOAD_ATTENDANCE,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}


export function GetExamPopulatePurge(examSessionId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.IExamPopulatePurge {
    return {
        examSessionId,
        type: actions.GET_EXAM_POPULATE_PURGE,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function GetDownloadStudentListReport(classId: string, courseId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.IDownloadStudentListReport {
    return {
        classId,
        courseId,
        type: actions.GET_DOWNLOAD_STUDENT_LIST_REPORT,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function UploadMultiQuestionsExcel(fileUploadId: string, fileUploadName: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): actionTypes.IUploadMultiQuestionsExcel {
    return {
        fileUploadId,
        fileUploadName,
        type: actions.UPLOAD_MULTI_QUESTIONS_EXCEL,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function GetSaveUploadedQuestions(trackingGuid: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.ISaveUploadedQuestions {
    return {
        trackingGuid,
        type: actions.SAVE_UPLOADED_QUESTIONS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function GetSendTwoFactorVerificationMail(target: string, isEmailAdding: boolean, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.IGetSendTwoFactorVerificationMail {
    return {
        target,
        isEmailAdding,
        type: actions.SEND_TWO_FACTOR_VERIFICATION_MAIL,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function MessageToIncompleters(activityId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.IMessageToIncompleters {
    return {
        activityId,
        type: actions.MESSAGE_TO_INCOMPLETERS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}

export function SyncQuestionsWithMadlen(QuestionIds: Array<string>, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISyncQuestionsWithMadlen {
    return {
        QuestionIds,
        callback,
        type: actions.SYNC_QUESTIONS_WITH_MADLEN,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}
